export default __webpack_public_path__ + "static/media/wind-panel.7ddb0ed2.svg";